import ConversationConstants from 'constants/ConversationConstants'
import { captureException } from 'utils/SentryHelpers'
import { captureResponseException } from 'utils/SentryHelpers'

const ConversationQueries = Marty.createQueries({
  id: 'ConversationQueries',

  fetchConversationsById(conversationIds) {
    return this.app.sources.ConversationAPI.fetchConversationsById(conversationIds)
      .then(res => {
        if (res.status === 200) {
          return this.dispatch(ConversationConstants.CONVERSATIONS_BY_ID_FETCH_DONE, res.body)
        } else {
          captureResponseException(res)
          return this.dispatch(ConversationConstants.CONVERSATIONS_BY_ID_FETCH_FAILED, res)
        }
      }).catch(error => {
        captureException(error)
        return this.dispatch(ConversationConstants.CONVERSATIONS_BY_ID_FETCH_FAILED, error)
      })
  },

  fetchConversation(conversationId) {
    const conversationPromise = this.app.sources.ConversationAPI.fetchConversation(conversationId)

    conversationPromise.then(res => {
      if (res.status === 200) {
        return this.dispatch(ConversationConstants.CONVERSATION_FETCH_DONE, conversationId, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(ConversationConstants.CONVERSATION_FETCH_FAILED, conversationId, res)
      }
    })

    return conversationPromise.catch(error => {
      captureException(error)
      return this.dispatch(ConversationConstants.CONVERSATION_FETCH_FAILED, conversationId, error)
    })
  },

  searchConversations(query) {
    const promise = this.app.sources.ConversationAPI.searchConversations(query)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(ConversationConstants.SEARCH_ALL_CONVERSATIONS_DONE, query, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(ConversationConstants.SEARCH_ALL_CONVERSATIONS_FAILED, query, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(ConversationConstants.SEARCH_ALL_CONVERSATIONS_FAILED, query, error)
    })
  }
})

export default ConversationQueries



// WEBPACK FOOTER //
// ./src/scripts/queries/ConversationQueries.js